import { PostStatus } from '../enums/PostStatus';

type chipColorType =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'
  | undefined;

export default function renderCorrectColorForPostStatus(
  status: string
): chipColorType {
  switch (status) {
    case PostStatus.PUBLISHED:
      return 'success';
      break;
    case PostStatus.REVIEW:
      return 'error';
      break;
    case PostStatus.DRAFT:
      return 'info';
      break;
    case PostStatus.SCHEDULED:
      return 'warning';
      break;
    default:
      return 'default';
  }
}
